import React from 'react';

import { Detail } from '../components/detail';
import { DetailContextProvider } from '../context/detail-context/detail-context';
import { ForecastingLoaderContainer } from './forecasting-loader-container/forecasting-loader-container';
import { PredictionsInfoContext } from '../context/predictions-info-context';
import { UserGridSettingsProvider } from '../reports/user-grid-settings/user-grid-settings-provider';
import { usePredictManagementContext } from '../../../predict-management/context/predict-management-context';

interface Props {
  isOnboardingPage?: boolean;
  workspaceId: string;
}

export const DetailContainer = ({ isOnboardingPage, workspaceId }: Props) => {
  const { organisation } = usePredictManagementContext();

  return (
    <DetailContextProvider workspaceId={workspaceId}>
      <UserGridSettingsProvider>
        <PredictionsInfoContext>
          <ForecastingLoaderContainer isOnboardingPage={isOnboardingPage}>
            {organisation ? <Detail organisationId={organisation.id} workspaceId={workspaceId} /> : null}
          </ForecastingLoaderContainer>
        </PredictionsInfoContext>
      </UserGridSettingsProvider>
    </DetailContextProvider>
  );
};
